import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem , Autocomplete} from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useBranchOfficeStore } from "../../../hooks/useBranchOfficeStore";
import { useBussinesAreaStore } from "../../../hooks/useBussinesAreaStore";

type Values = {
    id: number,
    name: string,
    description: string,
    idbranchoffice:number,
    status: string,
}

const states = [
    {name: 'Activo', value: '1'},
    {name: 'Desactivo', value: '0'},
]

export const BussinesAreaModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, areaSelected, listArea, clearState } = props;

    const { action, createBussinesArea, editBussinesArea } = useBussinesAreaStore();
    const { getBranchOffice } = useBranchOfficeStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [branchOfficeSelected, setBranchOfficeSelected] = useState<any>('');
    const [data, setData] = useState<Values>({
        id: areaSelected ? areaSelected.id :'',
        name: areaSelected ? areaSelected.name :'',
        description: areaSelected ? areaSelected.description :'',
        idbranchoffice: areaSelected ? areaSelected.idbranchoffice :'',
        status: areaSelected ? areaSelected.status :'1',
    });

    useEffect(() => {
        getBranchOfficeApi()
    },[])

    useEffect(() => {
        if(areaSelected && branchOffices){
            setCustomBranchOffice(areaSelected.idbranchoffice, branchOffices)
        }
    },[areaSelected, branchOffices])

    const setCustomBranchOffice = (idbranchoffice, branchOffices) => {
        const data = branchOffices.find(branch => branch.id == idbranchoffice);
        return setBranchOfficeSelected(data);
    }

    const getBranchOfficeApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getBranchOffice(search);
            if(!response){
                setBranchOffices([]);
                setLoadingdata(false);
                return false;
            }else{
                setBranchOffices(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.idbranchoffice) errors.idbranchoffice = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        if(areaSelected){
            const response:any = await editBussinesArea(areaSelected.id, values);
            if(response){
                listArea && listArea();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createBussinesArea(values);
            if(response){
                listArea && listArea();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar area de negocio' : (action == 'add' ? 'Nueva area de negocio' : 'Detalle del area de negocio')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Nombre:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Sucursal:</FormLabel>
                                            <Autocomplete
                                                id="idbranchoffice"
                                                size="small"
                                                value={!!branchOfficeSelected ? branchOfficeSelected : null}
                                                options={branchOffices || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small" 
                                                        error={errors.idbranchoffice && touched.idbranchoffice ? true : false}
                                                        helperText={errors.idbranchoffice && touched.idbranchoffice ? errors.idbranchoffice : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setBranchOfficeSelected(newValue)
                                                    setFieldValue('idbranchoffice', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="description"
                                                type="text" 
                                                name="description"
                                                fullWidth
                                                size="small"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={errors.description && touched.description ? true : false}
                                                helperText={errors.description && touched.description ? errors.description : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}